import { apiFetch } from '../api';

export type LoginResponse = {
  access_token?: string;
  user?: string;
  roles?: string[];
  organization?: string;
  organization_name?: string;
  organization_logo?: string;
  must_change_password?: boolean;
  requires_2fa?: boolean;
  setup_required?: boolean;
  email?: string;
  has_email?: boolean;
  message?: string;
  setup_url_dev?: string;
};

export async function login(
  organization: string,
  username: string,
  password?: string,
  two_factor_code?: string
): Promise<LoginResponse> {
  const data: LoginResponse = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ organization, username, password, two_factor_code }),
  });

  if (data.access_token) {
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('vereinsos_token', data.access_token);
    if (data.user) localStorage.setItem('user', data.user);
    if (data.roles) localStorage.setItem('roles', JSON.stringify(data.roles));
    if (data.organization) localStorage.setItem('organization', data.organization);
    localStorage.setItem('must_change_password', data.must_change_password ? 'true' : 'false');
    
    if (data.organization_name) {
      localStorage.setItem('organization_name', data.organization_name);
    }
    if (data.organization_logo && data.organization) {
      try {
        const key = `orgLogo_${data.organization}`;
        localStorage.setItem(key, data.organization_logo);
      } catch (e) {
        // ignore
      }
    }
  }

  return data;
}

export function logout() {
  localStorage.clear();
  window.location.href = '/login';
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem('token');
}

export function getAuth() {
  return { token: localStorage.getItem('vereinsos_token') || localStorage.getItem('token') };
}